module.exports = __webpack_public_path__ + "img/img26.b9fe09fa.svg";